import { StatusLabel } from '@shared/utils';

export enum ReklamaceTypEnum {
  ExistenceOpravneniKZastupovani = 'EXISTENCE_OPRAVNENI_K_ZASTUPOVANI',
  ChybnaDefiniceOpravneniKZastupovani = 'CHYBNA_DEFINICE_OPRAVNENI_K_ZASTUPOVANI',
  NeexistenceOpravneniKZastupovani = 'NEEXISTENCE_OPRAVNENI_K_ZASTUPOVANI',
  NeposkytnutiOpravneniKZastupovani = 'NEPOSKYTNUTI_OPRAVNENI_K_ZASTUPOVANI',
}

export const typyReklamace: Record<ReklamaceTypEnum, StatusLabel> = {
  EXISTENCE_OPRAVNENI_K_ZASTUPOVANI: {
    label: 'Existence oprávnění k zastupování',
  },
  CHYBNA_DEFINICE_OPRAVNENI_K_ZASTUPOVANI: {
    label: 'Chybná definice oprávnění k zastupování',
  },
  NEEXISTENCE_OPRAVNENI_K_ZASTUPOVANI: {
    label: 'Neexistence oprávnění k zastupování',
  },
  NEPOSKYTNUTI_OPRAVNENI_K_ZASTUPOVANI: {
    label: 'Neposkytnutí oprávnění k zastupování',
  },
};
